export const utmTypeAnalytics = {
  category: 'UTM-generator',
  action: 'Link_copy'
}
